import React, { useState } from 'react';
import { X, Menu } from 'lucide-react';

export default function FloatingContactForm({ settings, onClose, onEdit }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // In the editor, just show the form without submitting
  };

  return (
    <div className="floating-panel" data-testid="floating-contact-form">
      <div className="floating-panel-header">
        <span className="floating-panel-title">{settings?.form_title || 'Contact Us'}</span>
        <div className="floating-panel-controls">
          <button className="panel-control-btn" onClick={onEdit} title="Edit form settings">
            <Menu size={16} />
          </button>
          <button className="panel-control-btn" onClick={onClose} title="Close">
            <X size={16} />
          </button>
        </div>
      </div>
      
      <div className="floating-panel-body">
        <form onSubmit={handleSubmit}>
          {settings?.show_name !== false && (
            <div className="form-field">
              <input
                type="text"
                placeholder="Your Name"
                value={formData.name}
                onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                data-testid="contact-name-input"
              />
            </div>
          )}
          
          {settings?.show_email !== false && (
            <div className="form-field">
              <input
                type="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))}
                data-testid="contact-email-input"
              />
            </div>
          )}
          
          {settings?.show_phone !== false && (
            <div className="form-field">
              <input
                type="tel"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={(e) => setFormData(prev => ({ ...prev, phone: e.target.value }))}
                data-testid="contact-phone-input"
              />
            </div>
          )}
          
          {settings?.show_message !== false && (
            <div className="form-field">
              <textarea
                placeholder="Your Message"
                value={formData.message}
                onChange={(e) => setFormData(prev => ({ ...prev, message: e.target.value }))}
                data-testid="contact-message-input"
              />
            </div>
          )}
          
          <button 
            type="submit" 
            className="form-submit-btn"
            data-testid="contact-submit-btn"
          >
            {settings?.submit_label || 'Send'}
          </button>
        </form>
      </div>
    </div>
  );
}
